export const LX_CONFIG = {
    COMP_MV_BID: 'b_daodian_lowcode_fytonfgs_mv',
    CARD_MV_BID: 'b_daodian_lowcode_xojnooa2_mv',
    CARD_MC_BID: 'b_daodian_lowcode_pto79oug_mc',
    COMPARE_TAG_MV_BID: 'b_daodian_lowcode_qw69wibh_mv',
    COMPARE_TAG_MC_BID: 'b_daodian_lowcode_zi3e2mqq_mc'
};
export var SHOW_TYPE_ENUM;
(function (SHOW_TYPE_ENUM) {
    SHOW_TYPE_ENUM[SHOW_TYPE_ENUM["TWO_LIST"] = 1] = "TWO_LIST";
    SHOW_TYPE_ENUM[SHOW_TYPE_ENUM["SIGNAL_ROW"] = 2] = "SIGNAL_ROW";
})(SHOW_TYPE_ENUM || (SHOW_TYPE_ENUM = {}));
export const DYNAMIC_LIST_SCENE_TOKEN = 'dd-9cbc1c31cfbf2bba';
// 常用过滤标签
export const LABEL_FILTER_INFORS = [{
        label: '含早餐',
        value: 191046
    }, {
        label: '近地铁',
        value: 206823
    }, {
        label: '隔音好',
        value: 194316
    }, {
        label: '大床房',
        value: 182133
    }, {
        label: '4.8分以上',
        value: 191312
    }];
